export const CHECKOUT_URL = 'https://hvac-en.impultienda.ar/checkout/';

export const MOCKUP_URL =
  'https://cdn.magicpatterns.com/uploads/xpC1H9aaAHhx3FbMGPABth/MOCKUP_HVAC-EN.png';

export const AUTHOR_URL =
  'https://cdn.magicpatterns.com/uploads/7W3YzF5mCz6aLPh3ZcJz9J/JASON_MITCHELL_-_ECU_DECISION.png';

export const heroChecks = [
  'Instant Digital Access',
  'Field-Ready Checklists & Decision Maps',
  'Structured Electrical Troubleshooting Workflows',
  'Professional Documentation Templates',
  '7-Day Money-Back Guarantee',
];

export const scarcity = {
  total: 100,
  remaining: 7,
};

export const buyers = [
  { name: 'Carlos M.', country: 'Mexico' },
  { name: 'Valentina R.', country: 'Colombia' },
  { name: 'Diego F.', country: 'Argentina' },
  { name: 'Sofía L.', country: 'Chile' },
  { name: 'Andrés P.', country: 'Peru' },
  { name: 'Lucía G.', country: 'Spain' },
  { name: 'José A.', country: 'Venezuela' },
  { name: 'Mateo V.', country: 'Ecuador' },
  { name: 'Camila T.', country: 'Uruguay' },
  { name: 'Ricardo S.', country: 'Dominican Republic' },
  { name: 'Fernanda C.', country: 'Guatemala' },
  { name: 'Javier H.', country: 'Costa Rica' },
  { name: 'Gabriela N.', country: 'Puerto Rico' },
  { name: 'Luis E.', country: 'Bolivia' },
  { name: 'Martín O.', country: 'Paraguay' },
  { name: 'Isabel D.', country: 'Panama' },
];
